export default __webpack_public_path__ + "static/media/person.793c8a63.svg";